module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-45.021b9472.png";